import { ApiService } from '$lib/services/api';
import { postAuthenticationPathService } from '$lib/services/post-authentication-path';
import { validateUser } from '$lib/stores/user/action';
import { user } from '$lib/stores/user/store';
import { PAGES, REG_PATH_STEPS, AOFL_PRODUCT_UUIDS } from '$lib/utils/constants';
import { get } from 'svelte/store';
import {
	isPaymentProviderCompatible,
	isPrimaryPaymentProviderApplePay,
} from '$lib/utils/aofl-accounts';

export const policy = async () => {
	try {
		const currentUser = get(user);

		if (!currentUser.tokenValid) return false;
		const isAAOfferEligible = await ApiService.crossProductCheckEligibility({
			cross_product_aofl_product_uuid: AOFL_PRODUCT_UUIDS.ADVENTURE_ACADEMY,
		});

		if (!isAAOfferEligible.is_eligible) return false;

		// TODO: Remove this once Apple Pay is supported for AA offer.
		if (isPrimaryPaymentProviderApplePay()) return false;

		const hasCompatiblePaymentProvider = isPaymentProviderCompatible();
		if (!hasCompatiblePaymentProvider) return false;

		return true;
	} catch (error) {
		console.log('error', error);
		return false;
	}
};

export const policyExceptionHandler = async () => {
	const currentUser = get(user);
	if (!currentUser.tokenValid) return PAGES.INTERNAL.LOGIN;
	const nextStep = postAuthenticationPathService.getRedirectPath(currentUser);

	if (nextStep === PAGES.INTERNAL.AA_OFFER) {
		await ApiService.postCompletedStep({ completed_step: REG_PATH_STEPS.AA_OFFER });
		await validateUser();
		const updatedUser = get(user);
		const newNextStep = postAuthenticationPathService.getRedirectPath(updatedUser);
		return newNextStep;
	}
	return nextStep;
};
